import React, { useEffect, useState } from "react";
import AppIcon from "./AppIcon";

export const PRODUCT_SORT_OPTIONS = [
  { key: "max_discount", label: "بر اساس بیشترین تخفیف" },
  { key: "max_inventory", label: "بر اساس بیشترین موجودی" },
  { key: "min_inventory", label: "بر اساس کمترین موجودی" },
  { key: "max_expiry", label: "بر اساس بیشترین تاریخ انقضا" },
  { key: "min_expiry", label: "بر اساس کمترین تاریخ انقضا" },
  { key: "min_sales", label: "بر اساس کمترین فروش" },
  { key: "max_sales", label: "بر اساس بیشترین فروش" },
  { key: "newest", label: "بر اساس جدیدترین" },
  { key: "name", label: "بر اساس نام کالا" },
];

const ProductSortModal = ({
  activeSort,
  priceFrom,
  priceTo,
  onApply,
  onClose,
}) => {
  const [sort, setSort] = useState(activeSort || "");
  const [fromValue, setFromValue] = useState(priceFrom || "");
  const [toValue, setToValue] = useState(priceTo || "");

  useEffect(() => {
    setSort(activeSort || "");
    setFromValue(priceFrom || "");
    setToValue(priceTo || "");
  }, [activeSort, priceFrom, priceTo]);

  const handleApply = () => {
    onApply({
      sort,
      priceFrom: fromValue,
      priceTo: toValue,
    });
  };

  const handleReset = () => {
    setSort("");
    setFromValue("");
    setToValue("");
    onApply({
      sort: "",
      priceFrom: "",
      priceTo: "",
    });
  };

  return (
    <div className="sort-modal product-sort-modal">
      <div className="sort-modal-head">
        <h2>
          <AppIcon name="sort" width={22} height={22} alt="" />
          مرتب‌سازی
        </h2>
        <button type="button" className="sort-modal-close" onClick={onClose} aria-label="بستن">
          ×
        </button>
      </div>

      <div className="product-sort-price-range">
        <h3>محدوده قیمت</h3>
        <div className="product-sort-price-inputs">
          <input
            type="text"
            inputMode="numeric"
            placeholder="از مبلغ"
            value={fromValue}
            onChange={(event) =>
              setFromValue(event.target.value.replace(/[^\d]/g, ""))
            }
          />
          <span className="product-sort-price-sep">تا</span>
          <input
            type="text"
            inputMode="numeric"
            placeholder="تا مبلغ"
            value={toValue}
            onChange={(event) =>
              setToValue(event.target.value.replace(/[^\d]/g, ""))
            }
          />
        </div>
      </div>

      <div className="sort-modal-options">
        {PRODUCT_SORT_OPTIONS.map((option) => (
          <button
            key={option.key}
            type="button"
            className={`sort-modal-option ${sort === option.key ? "active product-sort-active" : ""}`}
            onClick={() => setSort(option.key)}
          >
            {option.label}
          </button>
        ))}
      </div>

      <div className="product-sort-actions">
        <button type="button" className="product-sort-apply-btn" onClick={handleApply}>
          اعمال
        </button>
        <button type="button" className="product-sort-reset-btn" onClick={handleReset}>
          بازنشانی
        </button>
      </div>
    </div>
  );
};

export default ProductSortModal;
